import { Model } from 'json-api-models';

import { Models, Schemas } from '../models.ts';

export class BulkAction extends Model<Schemas['bulkActions'], Models> {}
